export const QRLINX_STATUS = {
  AGUARDANDO_PAGAMENTO: 6, // Aguardando Pagamento Ocorre quando o pagamento foi criado pelo PDV.
  PAGAMENTO_REALIZADO: 7, // Ocorre quando o pagamento foi autorizado.
  FINALIZADO: 5, // Ocorre quando o pagamento foi confirmado pelo PDV.
  DESFEITO: 9, // Ocorre quando o PDV solicita o cancelamento antes de ser autorizado.
  CANCELADO: 4, // Ocorre quando o PDV solicita o cancelamento após a confirmação.
};
